export default "__VITE_ASSET__Xtj6MR4x__"